<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold text-red-400 my-5">{{ item[groupByFilters(form.getFieldValue('group_by'))] }}</div>
            <a-table :dataSource="item.matters" :columns="columns" :pagination="false"  class="tbl-receivable"></a-table>
          </div>
          <slot></slot>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <a-form v-show="!visibleRes" :form="form" @submit.prevent="handleReport">
      <div class="grid grid-cols-1 w-full md:w-1/2">
        <div class="flex flex-col md:flex-row">
          <a-form-item label="Select Responsible Lawyer">
            <a-radio-group v-decorator="['which_user',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeUser">
              <a-radio :style="radioStyle" :value="1">
                All Lawyers
              </a-radio>
              <a-radio :style="radioStyle" :value="2">
                Responsible Lawyer
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <SelectOption
            v-show="user_value === 2"
            url="/account/list/"
            label="User"
            field="user"
            :required="false"
            method="get"
            placeholder="Find A User"
            mode="multiple"
            class="w-full self-end"
          />
        </div>
        <div class="flex flex-col md:flex-row">
          <a-form-item label="Select Client/Matter">
            <a-radio-group v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleMatterClient">
              <a-radio :style="radioStyle" :value="1">
                All Clients
              </a-radio>
              <a-radio :style="radioStyle" :value="2">
                Specific Client
              </a-radio>
              <a-radio :style="radioStyle" :value="3">
                Specific Matter
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <selectSearch
            v-show="checked_matter_client === 3"
            :required="false"
            url="/matter/query/"
            :options="optionSearchMatter"
            class="self-end mt-8 md:mt-0 w-full"
            :is_include_matter="true"
            @selectSearch="handleSearch"
          />
          <selectSearch
            v-show="checked_matter_client === 2"
            :required="false"
            url="/contact/query/"
            :options="optionSearchContact"
            class="self-center mt-8 md:mt-0 w-full"
            :is_include_matter="false"
            @selectSearch="handleSearch"
          />
        </div>
        <a-form-item label="Group Results By">
          <a-select v-decorator="['group_by',{ initialValue: 1,rules: [{ required: true, message: 'this field is required.' }] }]">
            <a-select-option :value="1">
              Client
            </a-select-option>
            <a-select-option :value="3">
              Lawyer
            </a-select-option>
          </a-select>
        </a-form-item>
        <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>

        <a-form-item label="Matter status">
           <a-select v-decorator="['status',{ rules: [{ required: false, message: 'this field is required.' }] }]" allowClear>
             <a-select-option :value="1">
               All
             </a-select-option>
             <a-select-option :value="2">
               Pending
             </a-select-option>
             <a-select-option :value="3">
               Open
             </a-select-option>
             <a-select-option :value="4">
               Closed
             </a-select-option>
          </a-select>
        </a-form-item>

        <DateRangeComponent class="mt-4" :dateForm="form"/>
      </div>
      <BtnSubmitReport
        ref="reportSubmit"
        @backPage="$emit('changeTab','BillingReport')"
      />
    </a-form>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @hasDownloaded="hasDownloaded"
      @onProgress="onProgress"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from '@/components/pdf/ExportPdf'
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    title: 'Matter',
    dataIndex: 'name',
    key: '1',
    scopedSlots: { customRender: 'bill_id' },
  },
  {
    title: 'Account Receivable',
    dataIndex: 'account_receivable',
    key: '2',
  },
  {
    title: 'Expenses Progress',
    dataIndex: 'expenses_progress',
    key: '3',
  },
  {
    title: 'Work Progress',
    dataIndex: 'work_in_progress',
    key: '4',
  },
];

export default {
  name: "ComponentHistoryBill",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    DateRangeComponent,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      user_value: null,
      title:'Matter Balance Summary',
      columns,
      checked_matter_client: null,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  methods:{
    handleChangeUser({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ user: [] })
      this.user_value = value
    },
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query = []
            if (values.matter)  query.push({ field:'id', condition: '=', value: values.matter })
            if (values.contact) query.push({ field:'to_contact', condition: '=', value: values.contact })
            if (values.practice_area) query.push({ field:'matters__practice_area', condition: '=', value: values.practice_area })
            if (values.user && values.user.length) query.push({ field:'matters__responsible', condition: 'in', value: values.user })
            if (values.status) query.push({ field:'matters__status', condition: '=', value: values.status })
            if (values.from_date && values.to_date) query.push({ field:'created_at', condition: '>=', value: values.from_date },{ field:'created_at', condition: '<=', value: values.to_date })
            const { data }  = await axios.post('billing/report/summery/',{ group_by: values.group_by, query })
            this.visibleRes = true
            this.result     = Object.values(data)
          }catch (e) {
            this.visibleRes = false
            this.$message.error('Server Error')
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    }
  }
}
</script>

<style>
@import "../../style/style.css";
</style>

